import { Field, ObjectType, ID, Float, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Vendor } from '../vendor/Vendor'
import { RelatedEntity } from '../base/RelatedEntity'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProductVendorInput')
export class ProductVendor {
  @Field(() => ID)
  @Prop({ type: String, default: () => generateEntityId('pven') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  vendorCode: string

  @Field(() => Float)
  @Prop({ type: Number })
  price: number

  @Field(() => Vendor)
  @Prop({ type: RelatedEntity })
  vendor: Vendor

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => String)
  @Prop({ type: String })
  url: string

  //We just need for types
  vendors: ProductVendor[]
}
